<template>
  <div>
    <div
      class="d-flex justify-content-end"
      v-if="allowPaginate && total > perPage"
    >
      <div class="d-none d-md-block height-select mr-2" v-if="total_pages > 5">
        <selectFind
          :options="options"
          v-model="selected"
          label="text"
          @input="selectedChange"
        />
      </div>

      <b-pagination
        class="m-0"
        :total-rows="total"
        :per-page="perPage"
        first-class="first_link"
        prev-class="prev_link"
        next-class="next_link"
        last-class="last_link"
        ellipsis-class="ellipsis_link"
        v-model="currentPage"
        @change="ChangePage"
      />
    </div>
  </div>
</template>


<script>
export default {
  name: "paganationSearch",
  props: {
    allowPaginate: {
      type: Boolean,
      default: true,
    },
    total: {
      type: [String, Number],
      default: 0,
    },
    total_pages: {
      type: [String, Number],
      defualt: 0,
    },
    perPage: {
      type: [String, Number],
      default: 5,
    },
    value: {
      type: [String, Number],
      default: 1,
    },
    paging: {
      type: Function,
      default: () => [],
    },
    showSetting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentPage: this.value,
      options: [],
      selected: null,
      showComponet: false,
    };
  },
  methods: {
    selectedChange(item) {
      this.currentPage = item.value;
      this.$emit("input", item.value);
    },
    ChangePage(item) {
      let val = item.value || item;
      this.selected = {
        value: val,
        text: val,
      };

      this.$emit("input", val);
    },
    open() {
      this.showComponet = !this.showComponet;
    },
    checkedOption() {
      this.selected = {
        value: this.currentPage,
        text: this.currentPage,
      };
      this.options = Array.from(
        {
          length: Math.ceil(this.total_pages),
        },
        (v, k) => k + 1
      ).map((x) => {
        return {
          value: x,
          text: x,
        };
      });
    },
  },
  watch: {
    value(newValue) {
      this.selected = {
        value: newValue,
        text: newValue,
      };

      this.currentPage = newValue;
    },
    total_pages(oldvalue, newValue) {
      if (oldvalue !== newValue) {
        this.checkedOption();
      }
    },
  },
  created() {
    this.checkedOption();
  },
};
</script>

<style>
.height-select {
  height: 0;
}

.height-select
  > .form-row
  > .float-left
  > .multiselect__valid
  > .multiselect__tags {
  min-height: 20px !important;
  padding: 6px 33px 0px 33px !important;
}
</style>
